import Ad from './index';
export default class AdFeeds extends Ad {
  constructor(el) {
    super(el);
    this.commentLoaded = true;

    const { adShield } = window.store;
    const showAllAd = adShield.length === 0;
    this.canInsertFirstAd = showAllAd || adShield[0] === '0';
    this.canInsertRelatedNewsAd = showAllAd || adShield[0] === '0';
  }
}
